import { IKeywordResults } from '../../typings/IKeywordResults'
import mvFetch from '../helpers/mvFetch'

const keywordUrl = window.$mediavine.web.model.keywordSrc

export default class Keywords {
  private previousUrl: string

  constructor() {
    this.previousUrl = window.location.href
  }

  public getResults(): IKeywordResults | void {
    const currentUrl = window.location.href
    const { keywords } = window.$mediavine.web

    // sites with infinite scroll will need refreshed keyword data
    if (currentUrl !== this.previousUrl) {
      this.previousUrl = currentUrl
      this.keywordRequest()
    }

    if (keywords) {
      const { sales_cat, sales_safety, sales_kw } = keywords
      return { sales_cat, sales_safety, sales_kw }
    }
  }

  private keywordRequest(): void {
    mvFetch
      .fetchJson(`${keywordUrl}?pageUrl=${this.previousUrl}`)
      .then((response) => {
        const { sales_cat, sales_safety, sales_kw } = response
        this.updateKeywords({ sales_cat, sales_safety, sales_kw })
      })
      .catch((e) => {
        /* no op */
      })
  }

  private updateKeywords(updatedResults: IKeywordResults): void {
    window.$mediavine.web.keywords = updatedResults
  }
}
